module.exports = __webpack_public_path__ + "img/shenghuo_image.c5f50110.png";